import Resource from './Resource';

export default class Courses extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {}
		} = options;

		let config = {
			route: routeParams.courseSectionGuid ? 'courses/:courseSectionGuid' : 'courses',
			query: query,
			routeParams: routeParams,
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
